import React from "react";

const MoreVertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="black"
    className="w-4 h-4">
    <circle cx="12" cy="5.5" r="1.5" fill="black" />
    <circle cx="12" cy="12" r="1.5" fill="black" />
    <circle cx="12" cy="18.5" r="1.5" fill="black" />
  </svg>
);

export default MoreVertIcon;
